/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'src/App.scss';

import CustomInput, { SelectInput, SearchInput } from '../customInput';
import { ReactComponent as GoBackIcon } from 'src/assets/icons/goBack.svg';
import { ReactComponent as Lock } from 'src/assets/icons/lock.svg';

import SubFormTable from './subFormTable';
import { isValid, transformJson } from 'src/services/auth';
import { isDark } from '../DetectBrightness';

export default function SubForm({
  id,
  onClose,
  children,
  Class,
  allData,
  myExtraData,
  saveFunction,
  modo,
  tabIndex,
  blockAdd,
  formData,
}) {
  const thisFormData = allData || [];
  const blocked = thisFormData.bloreg === 'S' ? true : false;

  const allColunas = thisFormData[id];

  const jsonData = allColunas;

  const colunas = (() => {
    try {
      return JSON.parse(jsonData, 'Dados').Dados;
    } catch (error) {
      console.error('Erro ao fazer o parse do JSON:', error);
      return null;
    }
  })();

  const [listBlock, setListBlock] = useState([]);
  const [corFundo, setCorFundo] = useState('');
  const [contrasteColor, setConstrateColor] = useState('#000');

  useEffect(() => {
    setCorFundo(colunas?.corfundo);
    setConstrateColor(isDark(colunas?.corfundo));
  }, []);

  const keyToFind = id.replace(/Colunas$/i, '');
  const data = modo === 'add' ? [] : thisFormData[keyToFind];

  const remover = ['titulo', 'endpoint'];
  const novasColunas = Object.fromEntries(
    Object.entries(colunas).filter(([key]) => !remover.includes(key))
  );

  function handleSave(data) {
    saveFunction('A', data);
  }

  function closeSubItem() {
    onClose();
  }

  return (
    <div
      className={`subForm ${Class}`}
      style={{ backgroundColor: isValid(corFundo) ? corFundo : '#fff' }}
    >
      <span className="title">
        <h2 style={{ color: contrasteColor }}>
          {colunas?.titulo} {blocked && <Lock title={'Registro bloqueado.'} />}
          <hr />
        </h2>
        <div />
      </span>

      {/*<button onClick={onClose} className="exit">
        <GoBackIcon />
      </button>*/}
      <SubFormTable
        colunas={novasColunas}
        myData={allData}
        saveFunction={handleSave}
        subformKey={id.replace(/Colunas$/i, '')}
        OnClose={() => closeSubItem()}
        titulo={colunas?.titulo}
        extraData={myExtraData}
        extraExtraData={data}
        id={id.replace(/Colunas$/i, '')}
        block={blocked}
        tabIndex={tabIndex}
        corFundo={corFundo}
        blockAdd={blockAdd}
        formData={formData}
      />
    </div>
  );
}

SubForm.propTypes = {
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.func,
  Class: PropTypes.string,
  jsonData: PropTypes.object,
  saveFunction: PropTypes.func,
  modo: PropTypes.string,
  allData: PropTypes.object,
  myExtraData: PropTypes.object,
  tabIndex: PropTypes.number,
  blockAdd: PropTypes.bool,
  formData: PropTypes.object,
};
